export const authChannel = new BroadcastChannel('auth_sync_channel')